/**
 * @desc 订单退款明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getRefundItem.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/refundItem`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
